import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const PaymentModeMasterPopup = (props) => {
    return (
        <ModalBasic
            id="paymentModeMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Payment mode</span>
                <div className='item-grp grid grid-cols-1 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Payment mode</label>
                        <TextInput type='text'
                            id='paymentMode' name='paymentMode'
                            value={props.paymentObject.paymentMode}
                            handleChange={(event) => props.handleChange(event, 'paymentMode')}
                            className={props.validState?.error?.paymentMode !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.paymentObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}